import React from 'react';
import PropTypes from 'prop-types';

import Input, { Textarea } from '@marvelapp/marvel-ui/input';
import InputLabel from '@marvelapp/marvel-ui/input-label';
import Popover from '@marvelapp/marvel-ui/popover';
import Spacing from '@marvelapp/marvel-ui/spacing';
import Position from '@marvelapp/marvel-ui/position';

import styles from './fields.module.css';

export default function ContactUsInput({
  input,
  meta: { touched, error, invalid, valid, submitFailed },
  label,
  id,
  isTextarea = false,
  ...rest
}) {
  const Component = isTextarea ? Textarea : Input;
  return (
    <div className="position-relative">
      <Spacing type="margin" size="xxs" position="bottom">
        <Position type="relative">
          <InputLabel fontWeight="regular" htmlFor={id}>
            {label}
          </InputLabel>
        </Position>
      </Spacing>
      <Position type="relative">
        {touched && typeof error === 'string' && (
          <Popover
            align="right"
            alignContent="right"
            fullWidth
            isActive={invalid}
            maxWidth={300}
            position="top"
            size="small"
            type="error"
          >
            <div className={styles.popover}>{error}</div>
          </Popover>
        )}
        <Component
          {...input}
          {...rest}
          hasError={!!(touched && error)}
          showTick={touched && valid && submitFailed}
          id={id}
        />
      </Position>
    </div>
  );
}

ContactUsInput.propTypes = {
  id: PropTypes.string.isRequired,
  input: PropTypes.object.isRequired,
  isTextarea: PropTypes.bool,
  label: PropTypes.string.isRequired,
  meta: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/utils/forms/ContactUsInput.js